import BodyText, { BODY_TEXT_SIZES } from "@shared/ui/BodyText";
import Button from "@shared/ui/Button";
import Headline, { HEADLINE_SIZES } from "@shared/ui/Headline";
import Toast from "@shared/ui/Toast";
import React, { useState } from "react";
import { useIntl } from "react-intl";
import { Navigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import AuthPageLayout from "~/components/AuthPageLayout";
import { ForgotPasswordForm as Form } from "~/components/form";
import { FORGOT_PASSWORD } from "~/constants";
import { forgotPassword } from "~/services";
import { useGetOemBySlug } from "~/services/auth";
import { registerMixpanelEvent } from "~/utils/_mixpanel";
import { useNavigate } from "react-router-dom";

const ForgotPassword = () => {
  const { messages } = useIntl();
  const { modifier } = useParams();
  const { mutation } = forgotPassword();
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();

  const { error } = useGetOemBySlug(modifier);

  if (error) {
    if (typeof modifier !== "undefined") {
      return <Navigate to="/error-page/404" replace />;
    }
  }

  var renderPage = () => {
    return (
      <AuthPageLayout>
        <div className="flex justify-center items-center">
          <div className="o-column">
            <div className="auth-box">
              {submitted ? (
                <div className="form-authHead form-authHead--success form-authHead--center">
                  <Headline
                    size={HEADLINE_SIZES.MEDIUM}
                    className="mb-sm text-left"
                  >
                    {messages?.login?.forgotPassword.resetSuccess.title}
                  </Headline>
                  <BodyText
                    size={BODY_TEXT_SIZES.SMALL}
                    className="opacity-70 text-left"
                  >
                    {messages?.login?.forgotPassword.resetSuccess.message}
                  </BodyText>
                  <div className="mt-xl">
                    <Button
                      text={messages?.login?.forgotPassword.backToLogin}
                      onClick={() => navigate("/", { replace: true })}
                      fullWidth={true}
                    />
                  </div>
                </div>
              ) : (
                <>
                  <div className="form-authHead form-authHead--center form-authHead--success">
                    <Headline
                      size={HEADLINE_SIZES.MEDIUM}
                      className="mb-sm text-left"
                    >
                      {messages?.login?.forgotPassword.title}
                    </Headline>
                    <BodyText
                      size={BODY_TEXT_SIZES.SMALL}
                      className="opacity-70 text-left"
                    >
                      {messages?.login?.forgotPassword.message}
                    </BodyText>
                  </div>
                  <Form
                    callback={async (values) => {
                      const { email: userEmail } = values;
                      try {
                        registerMixpanelEvent(FORGOT_PASSWORD, {
                          oem: window.location.pathname
                            .split("/")
                            .slice(-1)
                            .join("")
                            .split("?")[0],
                          userEmail,
                        });
                        await mutation(values);
                      } catch (_e) {
                        // Swallow intentionally — prevent email enumeration
                      } finally {
                        setSubmitted(true);
                        toast(
                          <Toast message="An email with reset instructions has been sent" />,
                          { closeButton: false },
                        );
                      }
                    }}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </AuthPageLayout>
    );
  };

  return renderPage();
};

export default ForgotPassword;
